import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import { useApi } from "@/plugins/api/api";
import { List, WorkSchedule } from "./UserMasterWorkSchedule";
import WorkScheduleList from "./list/WorkScheduleList.vue";
import WorkScheduleTable from "./table/WorkScheduleTable.vue";
import { useAlert } from "@/plugins/alert/alert";
import UserInfoForm, { UserInfo } from "../info/UserInfoForm.vue";

type Props = {
  userId?: number;
};
type WorkScheduleUpdate = {
  count: number;
  updateStart: string;
  updateEnd: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'UserMasterWorkSchedule',
  props: {
    userId: null
  },
  setup(__props: any) {

const props = __props as {
  userId?: number;
};

const { Paths, $get, $post, $put, $delete } = useApi();
const { $alert } = useAlert();



const affiliationId = ref<number>();

const items = ref<WorkSchedule[]>([]);

const list = ref<List[]>([]);

const biko = ref<string>();

const form = ref<UserInfo>();

const getList = async () => {
  const result = await $get<List[]>(
    `${Paths.userMaster.workSchedule.list}/${props.userId}`
  );
  if (result) {
    list.value = result;
  }
  // 備考の情報を取得
  const resultBiko = await $get<UserInfo>(
    `${Paths.userMaster.info.default}/${props.userId}`
  );
  console.log(resultBiko, "resultBiko");
  biko.value = resultBiko?.mnid;
};

const getItems = async (userId: number, departmentId: number) => {
  const result = await $get<WorkSchedule[]>(
    Paths.userMaster.workSchedule.table,
    undefined,
    { userId, departmentId }
  );
  if (result) {
    items.value = result;
  }
};

const onListSelect = async (value?: number) => {
  console.log(value);
  affiliationId.value = value;
  if (value && props.userId) {
    await getItems(props.userId, value);
  } else {
    items.value = [];
  }
};

const onSend = async () => {
  const result = await $post<WorkScheduleUpdate>(
    `${Paths.userMaster.workSchedule.table}/${props.userId}/${affiliationId.value}`,
    items.value
  );
  if (result?.count !== 0) {
    $alert("success", "登録に成功しました。");
    if (result?.updateStart && result?.updateEnd) {
      const message = `${result?.updateStart}から${result?.updateEnd}までのシフトを更新しました。\n申請がある場合はすべて却下してください。`;
      $alert("warning", message, -1);
    }
    if (props.userId && affiliationId.value)
      await getItems(props.userId, affiliationId.value);
  }
};

const onSendBiko = async () => {
  // 備考欄の内容を更新する
  form.value = {
    mnid: biko.value
  };
  const result = await $put(
    `${Paths.userMaster.info.biko}/${props.userId}`,
    form.value
  );
  if (result) {
    $alert("success", "備考を更新しました。");
    if (props.userId && affiliationId.value)
      await getItems(props.userId, affiliationId.value);
  } else {
    $alert("error", "更新に失敗しました。");
  }
};

const onDelete = async (affiliationId: number) => {
  const response = await $delete(
    `${Paths.userMaster.workSchedule.default}/${props.userId}/${affiliationId}`
  );
  if (response != null) {
    $alert("success", "削除しました。");
    await getList();
  }
};

onMounted(async () => {
  await getList();
});

return { __sfc: true,Paths, $get, $post, $put, $delete, $alert, props, affiliationId, items, list, biko, form, getList, getItems, onListSelect, onSend, onSendBiko, onDelete, WorkScheduleList, WorkScheduleTable }
}

})